import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { buildApiUrl } from '@/utils/build-api-url';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors';

export interface GenerateInvitationLinkResponse {
  url: string;
  isExistingUser: boolean;
  isOptedOut: boolean;
}

export const useGenerateContributorInvitationLink = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ eventId, contributorId }: { eventId: string; contributorId: string }) => {
      const token = await getToken();
      return generateInvitationLink(eventId, contributorId, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY] });
    },
  });
};

const generateInvitationLink = async (
  eventId: string,
  contributorId: string,
  token: string,
): Promise<GenerateInvitationLinkResponse> => {
  const url = buildApiUrl(`invitations/event/${eventId}/contributors/${contributorId}/generate-link`);
  const response = await sendJSONRequest({ url, method: METHOD.POST, token });
  return response as GenerateInvitationLinkResponse;
};
